import { render, staticRenderFns } from "./WhiteButton.vue?vue&type=template&id=2e3a013a&scoped=true&"
import script from "./WhiteButton.vue?vue&type=script&lang=js&"
export * from "./WhiteButton.vue?vue&type=script&lang=js&"
import style0 from "./WhiteButton.vue?vue&type=style&index=0&id=2e3a013a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3a013a",
  null
  
)

export default component.exports